import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable, OnInit } from '@angular/core';
import { GeneralConstants } from 'src/app/core/constants/general.constants';
import { PaginationPaymentModel } from 'src/app/core/models/paginationPaymentModel.model';
import { PaymentModel } from 'src/app/core/models/payment.model';
import { PaymentHistoryRequest } from 'src/app/core/models/request/payment-history.request';
import { NotificationService } from 'src/app/core/services/notification.service';
import { environment } from 'src/environments/environment';
import { StorageConstants } from '../constants/storage.constants';
import { NotificationModel } from '../models/notification.model';
import { PaymentMethodTypeModel } from '../models/payment-method-type.model';
import { IReturnDetail, ReturnDetailResponse } from '../models/response/returns-detail.response';
import { SizeModel } from '../models/SizeModel.model';
import { IdentityService } from './identity.service';
import { RestService } from './rest.service';
import { StorageService } from './storage.service';
import { ReturnDetailModel } from '../models/returnDetail.model';
import { NativeBridgeService } from './native-bridge.service';
import { runtimeEnv } from 'src/environments/env-loader';

/**
 * PaymentService
 * @description
 * Permite la comunicación con el circuito de pago de Yacaré-Core.
 */
@Injectable()
export class PaymentsService implements OnInit {
  private notifications: NotificationModel[];
  emitLoadingExcelFinished: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private rest: RestService,
    // private userService: UserService,
    private storage: StorageService,
    private notificationService: NotificationService,
    private identityService: IdentityService,
    private nativeBridgeService: NativeBridgeService
  ) {
    this.notifications = new Array<NotificationModel>();
    this.notifications = [
      { error: 401, messenger: 'Se perdio la sesion', title: 'Movimientos', type: 2, configNotification: null },
      { error: 402, messenger: 'Se perdio la sesion 402', title: 'Movimientos', type: 2, configNotification: null },
      { error: 403, messenger: 'Se perdio la sesion 403', title: 'Movimientos', type: 2, configNotification: null },
      { error: 404, messenger: 'Se perdio la sesion 404', title: 'Movimientos', type: 2, configNotification: null }
    ];
  }

  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnInit() {
    this.notifications = new Array<NotificationModel>();
    this.notifications = [
      { error: 401, messenger: 'Se perdio la sesion', title: 'Movimientos', type: 2, configNotification: null },
      { error: 402, messenger: 'Se perdio la sesion 402', title: 'Movimientos', type: 2, configNotification: null },
      { error: 403, messenger: 'Se perdio la sesion 403', title: 'Movimientos', type: 2, configNotification: null },
      { error: 404, messenger: 'Se perdio la sesion 404', title: 'Movimientos', type: 2, configNotification: null }
    ];
  }

  public async getPaymentHistory(request: PaymentHistoryRequest): Promise<PaginationPaymentModel> {
    let endPoint = GeneralConstants.getMovements;
    return this.getPaymentGeneric(request, endPoint);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Los meses son basados en cero
    const day = ('0' + date.getDate()).slice(-2);
    return `${day}/${month}/${year}`;
  }

  public async getPaymentDetail(id: number): Promise<any> {
    const endPoint = GeneralConstants.paymentDetail;
    try {
      let result = await this.rest.get(endPoint + '/' + id, {});
      if (result.listOfResults) {
        return result.listOfResults.listOfResult;
      }
    } catch (e) {
      console.log(e);
      this.notificationService.showError('Error al obtener detalle de movimiento');
    }
  }

  public async getMovementDetail(id: number): Promise<any> {
    const endPoint = GeneralConstants.movementDetail;
    try {
      let result = await this.rest.get(endPoint + '/' + id, {});
      if (result.object) {
        return result.object;
      }
    } catch (e) {
      this.notificationService.showError('Error al obtener detalle de movimiento');
    }
  }

  private returnsDetailAdaptor(listOfResults: IReturnDetail[]): ReturnDetailModel[] {
    let adaptedList: ReturnDetailModel[] = [];

    adaptedList = listOfResults.map((returnDetail) => {
      return new ReturnDetailModel(
        returnDetail.id,
        returnDetail.fecha,
        returnDetail.estado,
        returnDetail.monto,
        returnDetail.titulo
      );
    });

    return adaptedList;
  }

  public async getPaymentTotalSize(request: PaymentHistoryRequest): Promise<SizeModel> {
    const endPoint = GeneralConstants.getMovements;
    let result = new SizeModel();
    try {
      let response = await this.rest.post(endPoint, request);
      result.size = response.listOfResults ? response.listOfResults.size : 0;
      return result;
    } catch (e) {
      console.log(e);
    }
  }

  private async getPaymentGeneric(
    request: PaymentHistoryRequest,
    endPointUrl: string
  ): Promise<PaginationPaymentModel> {
    const endPoint = endPointUrl;
    let result = new PaginationPaymentModel();

    let response = await this.rest
      .post(endPoint, request)
      .then(
        (response) => {
          if (response.message != null) {
            this.notificationService.showInfo(response.message, 'Movimientos');
          }
          return response;
        },
        (error: HttpErrorResponse): any => {
          throw new Error(error.message);
        }
      )
      .catch((error) => {
        //this.notifications.find(notification => notification.error == error)
        throw new Error(error.message);
      });
    if (response.listOfResults !== null) {
      let collection = new Array<PaymentModel>();
      for (let item of response.listOfResults.listOfResult) {
        let paymentItem = new PaymentModel();
        paymentItem.balanceCuenta = item.balanceCuenta;
        paymentItem.comprobanteDisponible = item.comprobanteDisponible;
        paymentItem.descripcion = item.descripcion;
        paymentItem.estado = item.estado;
        paymentItem.fecha = new Date(item.fecha);
        paymentItem.fechaAcreditacion = item.fechaAcreditacion ? new Date(item.fechaAcreditacion) : null;
        paymentItem.id = item.id;
        paymentItem.idMovOrigin = item.idMovOrigin ? item.idMovOrigin : '-';
        paymentItem.monto = item.monto;
        paymentItem.mpTipo = new PaymentMethodTypeModel();
        paymentItem.mpTipo.id = item.mpTipo.id;
        paymentItem.mpTipo.descripcion = item.mpTipo.descripcion;
        paymentItem.mpTipo.fechaVigDesde = item.mpTipo.fechaVigDesde;
        paymentItem.mpTipo.nombre = item.mpTipo.nombre;
        paymentItem.nroTarjeta = item.nroTarjeta;
        paymentItem.observaciones = item.observaciones;
        paymentItem.tipoMovimiento = item.tipoMovimiento;
        paymentItem.conceptoTipo = item.conceptoTipo;
        paymentItem.titulo = item.titulo;
        paymentItem.imgId = item.imgId;
        paymentItem.sucursal = item.sucursal ? item.sucursal : '-';
        paymentItem.caja = item.caja ? item.caja : '-';
        paymentItem.referencia = item.referencia;
        paymentItem.transform();
        paymentItem.cuilCuitContraparte = item.cuilCuitContraparte;
        paymentItem.cvuContraparte = item.cvuContraparte;
        paymentItem.billetera = item.billetera;
        paymentItem.debinId = item.conceptoNroComprobante;
        paymentItem.importe = item.monto;
        paymentItem.medioPagoView = item.mpTipo.nombre;

        collection.push(paymentItem);
      }

      result.list = collection;
      result.size = response.listOfResults.size;
      result.totalPage = response.listOfResults.totalPage;
      result.totalAmount = response.listOfResults.totalAmount;
      result.totalAmountGeneral = response.listOfResults.totalAmountGeneral;
    }
    return result;
  }

  public getQREMVco(sucursalId: number = 0, cajaId?: number): Promise<string> {
    const endPoint = sucursalId != 0 ? GeneralConstants.getQREMVcoSucursal : GeneralConstants.getQREMVco;
    return new Promise((resolve, reject) => {
      this.rest
        .post(endPoint, sucursalId != 0 ? { idSucursal: sucursalId, idCaja: cajaId } : {})
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }

  downloadTicket(ticketNumber: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = runtimeEnv.APIURL + '/' + 'payment/descargarComprobante' + '/' + ticketNumber;
      let headers = new Headers();
      headers.append('Authorization', 'Bearer ' + this.storage.get(StorageConstants.token));

      fetch(url, { headers })
        .then((response) => response.arrayBuffer())
        .then((arrayBuffer) => {
          // Convert the ArrayBuffer to a base64 string
          const uint8Array = new Uint8Array(arrayBuffer);
          const base64String = btoa(String.fromCharCode.apply(null, uint8Array));

          // Create a download link
          const downloadLink = document.createElement('a');
          downloadLink.href = `data:application/pdf;filename=${ticketNumber};base64,` + base64String;
          downloadLink.target = '_blank'; // Open in a new tab

          // Set the file name
          downloadLink.download = 'Comprobante_Movimiento_fiserv_' + ticketNumber + '.pdf';

          // Simulate a click on the link to start the download
          downloadLink.click();

          this.notificationService.showSuccess('Descargando comprobante.');
          resolve(true);
        })
        .catch((_error) => {
          this.notificationService.showError('Error al descargar comprobante.');
          reject(false);
        });
    });
  }

  downloadExcel(request: PaymentHistoryRequest): Promise<string> {
    return new Promise((resolve, reject) => {
      this.rest
        .post(GeneralConstants.exportMovementsToExcel, request)
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          reject(new Error(error?.message));
        });
    });
  }
}
